import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AuthModule } from '@forgerock/backstage-ui-core';
import { map } from 'rxjs/operators';
import {
  SearchFilterPaginationComponent
} from '../../search-params/search-filter-pagination/search-filter-pagination.component';
import {
  SearchResultWrapperComponent
} from '../../search-result/search-result-wrapper/search-result-wrapper.component';
import { TabSectionComponent } from '../tab-section/tab-section.component';
import { TabService } from '../tab.service';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: [ './tab.component.scss' ],
  imports: [ TabSectionComponent, SearchResultWrapperComponent, SearchFilterPaginationComponent, AsyncPipe, AuthModule ]
})
export class TabComponent {
  private tabService = inject(TabService);
  sections = this.tabService.results.pipe(map(it => it.sections));
}
